import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDDW64bqkSIw7pxZn5ShlLqoFy7CQKwZrA",
    authDomain: "smart-869db.firebaseapp.com",
    projectId: "smart-869db",
    storageBucket: "smart-869db.firebasestorage.app",
    messagingSenderId: "979388205419",
    appId: "1:979388205419:web:ea129ea38c13201d8f242e",
    measurementId: "G-24X4DPWNCR"
};
  
const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };